"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2577],{

/***/ 76173:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ CancelPayOrderLocal; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(57800);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  mutation CancelPayOrderLocal($params: CancelPayOrderLocalParams!) {\n    cancelPayOrderLocal(params: $params) {\n      status\n      id\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var CancelPayOrderLocal = function() {
    return (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject());
};


/***/ }),

/***/ 42737:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ OrderSummary; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(98788);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(66383);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(45680);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_FormComponents__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(61912);
/* harmony import */ var _styles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(58055);
/* harmony import */ var _OrderSummary_styles__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70146);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(70754);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(91655);
/* harmony import */ var _hooks_useOrderState__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(778);
/* harmony import */ var _config_environment__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(60031);
/* harmony import */ var _utils_formatters_CurrencyFormatter__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(23239);
/* harmony import */ var _hooks_useAuth__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(75625);
/* harmony import */ var _hooks_usePermissions__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(18782);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(67294);
/* harmony import */ var _paymentMethod_zustand_paymentMethodStore__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(69355);
/* harmony import */ var _paymentMethod_zustand_localPaymentOptionsStore__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(57500);
/* harmony import */ var _queries_payment_mutations_cancelPayOrderLocal__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(76173);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(50319);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(8881);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _hooks_useEventTracking__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(66630);
/* harmony import */ var _services_openreplay__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(2116);
/* harmony import */ var _validators_Events_Error__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(64785);























var currencyFormatter = new _utils_formatters_CurrencyFormatter__WEBPACK_IMPORTED_MODULE_16__/* .CurrencyFormatter */ .J({
    fallback: _config_environment__WEBPACK_IMPORTED_MODULE_5__/* .NEXT_PUBLIC_NO_PRICE_FALLBACK */ .uh
});
var zeroCurrencyFormatter = new _utils_formatters_CurrencyFormatter__WEBPACK_IMPORTED_MODULE_16__/* .CurrencyFormatter */ .J({
    fallback: "$0"
});
var OrderSummary = function(param) {
    var isDelivery = param.isDelivery, deliveryCost = param.deliveryCost, oldDeliveryCost = param.oldDeliveryCost, cardData = param.cardData, handleNext = param.handleNext, _buttonText = param.buttonText, buttonText = _buttonText === void 0 ? "Siguiente" : _buttonText, _variant = param.variant, variant = _variant === void 0 ? "desktop" : _variant, _showDelivery = param.showDelivery, showDelivery = _showDelivery === void 0 ? true : _showDelivery, _showInsurance = param.showInsurance, showInsurance = _showInsurance === void 0 ? true : _showInsurance, _showMekiCredits = param.showMekiCredits, showMekiCredits = _showMekiCredits === void 0 ? true : _showMekiCredits, parentLoading = param.loading;
    var userCan = (0,_hooks_usePermissions__WEBPACK_IMPORTED_MODULE_7__/* .usePermissions */ .T)().userCan;
    var isLocalVendor = userCan("LOCAL_VENDOR");
    var ref = (0,_hooks_useAuth__WEBPACK_IMPORTED_MODULE_6__/* .useAuth */ .a)(), user = ref.appUser;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_12__.useRouter)();
    var track = (0,_hooks_useEventTracking__WEBPACK_IMPORTED_MODULE_13__/* .useEventTracking */ .A)().track;
    var trackIssue = (0,_services_openreplay__WEBPACK_IMPORTED_MODULE_14__/* .useOpenReplayTracking */ .WK)().trackIssue;
    var ref1 = (0,_hooks_useOrderState__WEBPACK_IMPORTED_MODULE_4__/* .useOrderState */ .h)(), currentOrder = ref1.order, loadingCurrentOrder = ref1.loadingCurrentOrder;
    var installments = ((currentOrder === null || currentOrder === void 0 ? void 0 : currentOrder.metadata) || {}).installments;
    var ref2 = (0,_paymentMethod_zustand_paymentMethodStore__WEBPACK_IMPORTED_MODULE_9__/* .usePaymentSelectors */ .M6)(), mekiCreditsChecked = ref2.mekiCreditsChecked, insuranceId = ref2.insuranceId, totalReimbursement = ref2.totalReimbursement, totalDeductible = ref2.totalDeductible, totalCopay = ref2.totalCopay;
    var ref3 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)((0,_apollo_client__WEBPACK_IMPORTED_MODULE_18__/* .useMutation */ .D)((0,_queries_payment_mutations_cancelPayOrderLocal__WEBPACK_IMPORTED_MODULE_19__/* .CancelPayOrderLocal */ .S)()), 2), cancelPayOrderLocal = ref3[0], ref4 = ref3[1], cancelPayOrderLocalLoading = ref4.loading;
    var ref5 = (0,_paymentMethod_zustand_localPaymentOptionsStore__WEBPACK_IMPORTED_MODULE_10__/* .useLocalPaymentOptionsActions */ .e)(), cleanValuesLocal = ref5.cleanValues;
    var handleCancelPayOrderLocal = (0,react__WEBPACK_IMPORTED_MODULE_8__.useCallback)(/*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)(function() {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_21__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    void cleanValuesLocal();
                    return [
                        4,
                        cancelPayOrderLocal({
                            variables: {
                                params: {
                                    orderUuid: currentOrder === null || currentOrder === void 0 ? void 0 : currentOrder.uuid
                                }
                            }
                        }).catch(function(e) {
                            void trackIssue("[CANCEL_PAY_ORDER_LOCAL]: Error cancelling pay order local", {
                                orderUuid: currentOrder === null || currentOrder === void 0 ? void 0 : currentOrder.uuid
                            });
                            void track(_validators_Events_Error__WEBPACK_IMPORTED_MODULE_15__/* .ErrorEventTypes.PaymentCancel */ .rf.PaymentCancel, {
                                type: "LOCAL",
                                error: e
                            });
                            throw e;
                        }).finally(function() {
                            void router.push((0,_utils__WEBPACK_IMPORTED_MODULE_11__/* .getRoute */ .Bv)("checkoutPaymentMethodLocal"));
                        })
                    ];
                case 1:
                    _state.sent();
                    void router.push((0,_utils__WEBPACK_IMPORTED_MODULE_11__/* .getRoute */ .Bv)("checkoutPaymentMethodLocal"));
                    return [
                        2
                    ];
            }
        });
    }), [
        cancelPayOrderLocal,
        cleanValuesLocal,
        currentOrder === null || currentOrder === void 0 ? void 0 : currentOrder.uuid,
        trackIssue,
        router,
        track, 
    ]);
    var sellDeductible = insuranceId ? totalCopay - totalDeductible : 0;
    var productsSubTotal = (0,react__WEBPACK_IMPORTED_MODULE_8__.useMemo)(function() {
        var _price, ref;
        return currentOrder === null || currentOrder === void 0 ? void 0 : currentOrder.orderDetails.reduce(function(acc, curr) {
            var ref1;
            return acc + ((ref = (_price = curr.price) !== null && _price !== void 0 ? _price : (ref1 = curr.product.discount) === null || ref1 === void 0 ? void 0 : ref1.price) !== null && ref !== void 0 ? ref : curr.product.price) * curr.quantity;
        }, 0);
    }, [
        currentOrder === null || currentOrder === void 0 ? void 0 : currentOrder.orderDetails
    ]);
    var productsQuantity = (0,react__WEBPACK_IMPORTED_MODULE_8__.useMemo)(function() {
        return currentOrder === null || currentOrder === void 0 ? void 0 : currentOrder.orderDetails.reduce(function(acc, curr) {
            return acc + curr.quantity;
        }, 0);
    }, [
        currentOrder === null || currentOrder === void 0 ? void 0 : currentOrder.orderDetails
    ]);
    var ref6;
    var userMekiCredits = (ref6 = user === null || user === void 0 ? void 0 : user.credits) !== null && ref6 !== void 0 ? ref6 : 0;
    var ref7 = (0,react__WEBPACK_IMPORTED_MODULE_8__.useMemo)(function() {
        var subTotal = productsSubTotal + (showDelivery ? deliveryCost : 0);
        var usedMekiCredits = showMekiCredits && mekiCreditsChecked ? Math.min(subTotal, userMekiCredits) : 0;
        var insuranceTotalReimbursement = showInsurance && Boolean(insuranceId) ? totalReimbursement : 0;
        return {
            usedMekiCredits: usedMekiCredits,
            totalFinal: subTotal - insuranceTotalReimbursement - usedMekiCredits
        };
    }, [
        productsSubTotal,
        deliveryCost,
        totalReimbursement,
        totalDeductible,
        userMekiCredits,
        mekiCreditsChecked,
        insuranceId,
        showInsurance,
        showMekiCredits,
        showDelivery, 
    ]), usedMekiCredits = ref7.usedMekiCredits, totalFinal = ref7.totalFinal;
    var loading = loadingCurrentOrder || parentLoading;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_OrderSummary_styles__WEBPACK_IMPORTED_MODULE_3__/* .OrderSummaryCard */ .vq, {
        variant: variant,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_OrderSummary_styles__WEBPACK_IMPORTED_MODULE_3__/* .OrderSummaryContainer */ .DV, {
                children: [
                    variant === "desktop" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styles__WEBPACK_IMPORTED_MODULE_2__/* .TitleTypography */ .dP, {
                        children: "Resumen compra"
                    }),
                    loading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(OrderSummarySkeleton, {
                        variant: variant
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_OrderSummary_styles__WEBPACK_IMPORTED_MODULE_3__/* .OrderSummaryDataContainer */ .jf, {
                        variant: variant,
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_OrderSummary_styles__WEBPACK_IMPORTED_MODULE_3__/* .OrderSummaryDetailContainer */ .am, {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_OrderSummary_styles__WEBPACK_IMPORTED_MODULE_3__/* .HorizontalContainer */ .bp, {
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_OrderSummary_styles__WEBPACK_IMPORTED_MODULE_3__/* .SubtotalTypography */ .cr, {
                                                children: [
                                                    "Productos (",
                                                    productsQuantity,
                                                    ")"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_OrderSummary_styles__WEBPACK_IMPORTED_MODULE_3__/* .SubtotalTypography */ .cr, {
                                                children: currencyFormatter.format(productsSubTotal)
                                            })
                                        ]
                                    }),
                                    showInsurance && Boolean(insuranceId) && (totalReimbursement > 0 || totalDeductible > 0 || totalCopay > 0) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_OrderSummary_styles__WEBPACK_IMPORTED_MODULE_3__/* .HorizontalContainer */ .bp, {
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_OrderSummary_styles__WEBPACK_IMPORTED_MODULE_3__/* .DetailTypography */ .$T, {
                                                        children: "Reembolso p\xf3liza"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_OrderSummary_styles__WEBPACK_IMPORTED_MODULE_3__/* .DetailTypography */ .$T, {
                                                        children: zeroCurrencyFormatter.format(totalReimbursement + totalDeductible)
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_OrderSummary_styles__WEBPACK_IMPORTED_MODULE_3__/* .HorizontalContainer */ .bp, {
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_OrderSummary_styles__WEBPACK_IMPORTED_MODULE_3__/* .DetailTypography */ .$T, {
                                                        children: "Deducible p\xf3liza"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_OrderSummary_styles__WEBPACK_IMPORTED_MODULE_3__/* .DetailTypography */ .$T, {
                                                        children: zeroCurrencyFormatter.format(totalDeductible)
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_OrderSummary_styles__WEBPACK_IMPORTED_MODULE_3__/* .HorizontalContainer */ .bp, {
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_OrderSummary_styles__WEBPACK_IMPORTED_MODULE_3__/* .DetailTypography */ .$T, {
                                                        bold: true,
                                                        children: "Aporte seguro"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_OrderSummary_styles__WEBPACK_IMPORTED_MODULE_3__/* .DetailTypography */ .$T, {
                                                        bold: true,
                                                        children: zeroCurrencyFormatter.format(totalReimbursement)
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_OrderSummary_styles__WEBPACK_IMPORTED_MODULE_3__/* .HorizontalContainer */ .bp, {
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_OrderSummary_styles__WEBPACK_IMPORTED_MODULE_3__/* .DetailTypography */ .$T, {
                                                        children: "Deducible venta"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_OrderSummary_styles__WEBPACK_IMPORTED_MODULE_3__/* .DetailTypography */ .$T, {
                                                        children: zeroCurrencyFormatter.format(sellDeductible)
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_OrderSummary_styles__WEBPACK_IMPORTED_MODULE_3__/* .HorizontalContainer */ .bp, {
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_OrderSummary_styles__WEBPACK_IMPORTED_MODULE_3__/* .DetailTypography */ .$T, {
                                                        bold: true,
                                                        children: "Valor a pagar productos"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_OrderSummary_styles__WEBPACK_IMPORTED_MODULE_3__/* .DetailTypography */ .$T, {
                                                        bold: true,
                                                        children: zeroCurrencyFormatter.format(productsSubTotal - totalReimbursement)
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    showDelivery && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                        children: isDelivery ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_OrderSummary_styles__WEBPACK_IMPORTED_MODULE_3__/* .HorizontalContainer */ .bp, {
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_OrderSummary_styles__WEBPACK_IMPORTED_MODULE_3__/* .DetailTypography */ .$T, {
                                                    children: "Despacho"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_OrderSummary_styles__WEBPACK_IMPORTED_MODULE_3__/* .DetailTypography */ .$T, {
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_OrderSummary_styles__WEBPACK_IMPORTED_MODULE_3__/* .DiscountSpan */ .c_, {
                                                            children: oldDeliveryCost && oldDeliveryCost > deliveryCost ? currencyFormatter.format(oldDeliveryCost) : null
                                                        }),
                                                        deliveryCost > 0 ? currencyFormatter.format(deliveryCost) : "Gratis"
                                                    ]
                                                })
                                            ]
                                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_OrderSummary_styles__WEBPACK_IMPORTED_MODULE_3__/* .HorizontalContainer */ .bp, {
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_OrderSummary_styles__WEBPACK_IMPORTED_MODULE_3__/* .DetailTypography */ .$T, {
                                                    children: "Retiro en tienda"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_OrderSummary_styles__WEBPACK_IMPORTED_MODULE_3__/* .DetailTypography */ .$T, {
                                                    children: "Gratis"
                                                })
                                            ]
                                        })
                                    }),
                                    !isLocalVendor && mekiCreditsChecked && showMekiCredits && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_OrderSummary_styles__WEBPACK_IMPORTED_MODULE_3__/* .HorizontalContainer */ .bp, {
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_OrderSummary_styles__WEBPACK_IMPORTED_MODULE_3__/* .DetailTypography */ .$T, {
                                                children: "Cr\xe9ditos Meki"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_OrderSummary_styles__WEBPACK_IMPORTED_MODULE_3__/* .DetailTypography */ .$T, {
                                                children: [
                                                    "-",
                                                    zeroCurrencyFormatter.format(usedMekiCredits)
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            variant !== "fixed-bottom" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_OrderSummary_styles__WEBPACK_IMPORTED_MODULE_3__/* .TotalContainer */ .rl, {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_OrderSummary_styles__WEBPACK_IMPORTED_MODULE_3__/* .HorizontalContainer */ .bp, {
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_OrderSummary_styles__WEBPACK_IMPORTED_MODULE_3__/* .TotalTypography */ .bK, {
                                                children: "Total a pagar"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_OrderSummary_styles__WEBPACK_IMPORTED_MODULE_3__/* .TotalTypography */ .bK, {
                                                children: zeroCurrencyFormatter.format(totalFinal)
                                            })
                                        ]
                                    }),
                                    installments > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_OrderSummary_styles__WEBPACK_IMPORTED_MODULE_3__/* .HorizontalContainer */ .bp, {
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_OrderSummary_styles__WEBPACK_IMPORTED_MODULE_3__/* .DetailTypography */ .$T, {
                                                bold: true,
                                                children: "N\xba de cuotas"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_OrderSummary_styles__WEBPACK_IMPORTED_MODULE_3__/* .DetailTypography */ .$T, {
                                                bold: true,
                                                children: [
                                                    installments,
                                                    " cuotas"
                                                ]
                                            })
                                        ]
                                    }),
                                    cardData && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_OrderSummary_styles__WEBPACK_IMPORTED_MODULE_3__/* .HorizontalContainer */ .bp, {
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_OrderSummary_styles__WEBPACK_IMPORTED_MODULE_3__/* .DetailTypography */ .$T, {}),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_OrderSummary_styles__WEBPACK_IMPORTED_MODULE_3__/* .DetailTypography */ .$T, {
                                                children: cardData
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            handleNext && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_FormComponents__WEBPACK_IMPORTED_MODULE_1__/* .SubmitButton */ .Mm, {
                disabled: loading,
                onClick: handleNext,
                children: buttonText
            }),
            isLocalVendor && (currentOrder === null || currentOrder === void 0 ? void 0 : currentOrder.status) === "PAYMENT_VALIDATION" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_FormComponents__WEBPACK_IMPORTED_MODULE_1__/* .VendorLocalCancelButton */ .ot, {
                disabled: cancelPayOrderLocalLoading,
                onClick: handleCancelPayOrderLocal,
                variant: "outlined",
                children: cancelPayOrderLocalLoading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z, {
                    size: 20
                }) : "Cancelar"
            })
        ]
    });
};
var OrderSummarySkeleton = function(param) {
    var variant = param.variant;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_OrderSummary_styles__WEBPACK_IMPORTED_MODULE_3__/* .OrderSummaryDataContainer */ .jf, {
        variant: variant,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_OrderSummary_styles__WEBPACK_IMPORTED_MODULE_3__/* .OrderSummaryDetailContainer */ .am, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_OrderSummary_styles__WEBPACK_IMPORTED_MODULE_3__/* .HorizontalContainer */ .bp, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z, {
                                variant: "rounded",
                                width: 160,
                                height: 20
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z, {
                                variant: "rounded",
                                width: 80,
                                height: 20
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_OrderSummary_styles__WEBPACK_IMPORTED_MODULE_3__/* .HorizontalContainer */ .bp, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z, {
                                variant: "rounded",
                                width: 160,
                                height: 18
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z, {
                                variant: "rounded",
                                width: 80,
                                height: 20
                            })
                        ]
                    })
                ]
            }),
            variant !== "fixed-bottom" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_OrderSummary_styles__WEBPACK_IMPORTED_MODULE_3__/* .TotalContainer */ .rl, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_OrderSummary_styles__WEBPACK_IMPORTED_MODULE_3__/* .HorizontalContainer */ .bp, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z, {
                            variant: "rounded",
                            width: 160,
                            height: 24
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z, {
                            variant: "rounded",
                            width: 80,
                            height: 24
                        })
                    ]
                })
            })
        ]
    });
};


/***/ }),

/***/ 79728:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ CheckoutTitle; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(91655);
/* harmony import */ var _styles__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(58055);



var CheckoutTitle = function(param) {
    var title = param.title, _loading = param.loading, loading = _loading === void 0 ? false : _loading;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            loading && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                variant: "rectangular",
                width: 240,
                height: 36
            }),
            !loading && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styles__WEBPACK_IMPORTED_MODULE_1__/* .TitleTypography */ .dP, {
                children: title
            })
        ]
    });
};


/***/ })

}]);